import { createAction } from "redux-actions";

// fetch all connected customers
export const FETCH_CONNECTED_CUSTOMERS = "FETCH_CONNECTED_CUSTOMERS";
export const fetchConnectedCustomers = createAction(FETCH_CONNECTED_CUSTOMERS);

export const FETCH_CONNECTED_CUSTOMERS_REQUESTED = "FETCH_CONNECTED_CUSTOMERS_REQUESTED";
export const fetchConnectedCustomersRequested = createAction(FETCH_CONNECTED_CUSTOMERS_REQUESTED);

export const FETCH_CONNECTED_CUSTOMERS_FAILURE = "FETCH_CONNECTED_CUSTOMERS_FAILURE";
export const fetchConnectedCustomersFailure = createAction(FETCH_CONNECTED_CUSTOMERS_FAILURE);

export const FETCH_CONNECTED_CUSTOMERS_SUCCESS = "FETCH_CONNECTED_CUSTOMERS_SUCCESS";
export const fetchConnectedCustomersSuccess = createAction(FETCH_CONNECTED_CUSTOMERS_SUCCESS);
